module.exports = __webpack_public_path__ + "img/67.1.2e8fc0d0.jpg";